import { PageMeta } from "./PageMeta";
import { useLocalization } from "../hooks/useLocalization";
import { useLocalePath } from "../hooks/useLocalePath";

interface RoutePageMetaProps {
  page:
    | "HOME"
    | "ABOUT"
    | "SCHEDULE"
    | "RESULTS"
    | "GALLERY"
    | "LEADERBOARD"
    | "STATS"
    | "CHAMPIONS"
    | "TEAMS"
    | "TERMS"
    | "PRIVACY"
    | "NOT_FOUND";
  internalPath?: string;
  titleOverride?: string;
  descriptionOverride?: string;
  noindex?: boolean;
}

const DEFAULT_INTERNAL_PATHS: Record<RoutePageMetaProps["page"], string> = {
  HOME: "/",
  ABOUT: "/about",
  SCHEDULE: "/schedule",
  RESULTS: "/results",
  GALLERY: "/gallery",
  LEADERBOARD: "/fpl/leaderboard",
  STATS: "/fpl/stats",
  CHAMPIONS: "/fpl/champions",
  TEAMS: "/fpl/teams",
  TERMS: "/terms",
  PRIVACY: "/privacy",
  NOT_FOUND: "/404",
};

export const RoutePageMeta = ({
  page,
  internalPath,
  titleOverride,
  descriptionOverride,
  noindex,
}: RoutePageMetaProps) => {
  const { strings } = useLocalization();
  const { localized } = useLocalePath();
  const meta = strings.SEO[page];
  const resolvedInternalPath = internalPath ?? DEFAULT_INTERNAL_PATHS[page];

  return (
    <PageMeta
      title={titleOverride ?? meta.TITLE}
      description={descriptionOverride ?? meta.DESCRIPTION}
      pathname={localized(resolvedInternalPath)}
      internalPath={resolvedInternalPath}
      noindex={noindex ?? page === "NOT_FOUND"}
    />
  );
};

export { PageMeta };
